import { IService } from './IService';
import { AngularFireDatabase } from '@angular/fire/database';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppSettings } from './app-settings';
import { ToastService } from './toast-service';
import { LoadingService } from './loading-service';

@Injectable({ providedIn: 'root' })
export class ProfileService implements IService {

    constructor(public af: AngularFireDatabase, private loadingService: LoadingService, private toastCtrl: ToastService) { }

    getTitle = (): string => 'Profile';

    getAllThemes = (): Array<any> => {
        return [
            { 'url': 'profile/0', 'title': 'Profile With Big Avatar', 'theme': 'layout1' },
            { 'url': 'profile/1', 'title': 'Profile With Comments', 'theme': 'layout2' },
            { 'url': 'profile/2', 'title': 'Profile With Cards Image', 'theme': 'layout3' },
            { 'url': 'profile/3', 'title': 'Profile With Cards', 'theme': 'layout4' },
            { 'url': 'profile/4', 'title': 'Profile With Big Avatar 2', 'theme': 'layout5' }
        ];
    }

    getDataForTheme = (menuItem: any): any => {
        return this[
            'getDataFor' +
            menuItem.theme.charAt(0).toUpperCase() +
            menuItem.theme.slice(1)
        ]();
    }

    //* Data Set for page 1
    getDataForLayout1 = (): any => {
        return {
            'toolbarTitle': 'Profile With Big Avatar',
            'image': 'assets/imgs/avatar/24.jpg',
            'title': 'Claire Stewart',
            'subtitle': 'Extreme coffee lover. Twitter maven. Internet practitioner. Beeraholic.',
            'buttonFollow': 'Follow',
            'buttonMessage': 'Message',
            'category': 'Favorite',
            'image1': 'assets/imgs/background/1.jpg',
            'image2': 'assets/imgs/background/2.jpg',
            'image3': 'assets/imgs/background/3.jpg',
        };
    }

    //* Data Set for page 2
    getDataForLayout2 = (): any => {
        return {
            'toolbarTitle': 'Profile With Comments',
            'image': 'assets/imgs/avatar/20.jpg',
            'title': 'Benjamin Wilson',
            'subtitle': 'Extreme coffee lover. Twitter maven. Internet practitioner. Beeraholic.',
            'followers': 'Followers',
            'valueFollowers': '439',
            'following': 'Following',
            'valueFollowing': '297',
            'button': 'Follow',
            'items': [
              {
                  'id': 1,
                  'image': 'assets/imgs/avatar/20.jpg',
                  'title': 'Erica Romaguera',
                  'time': '22 August',
                  'description': 'If you could have any kind of pet, what would you choose?',
              },
              {
                  'id': 2,
                  'image': 'assets/imgs/avatar/21.jpg',
                  'title': 'Caleigh Jerde',
                  'time': '19 August',
                  'description': 'If you could learn any language, what would you choose?',
              },
              {
                  'id': 3,
                  'image': 'assets/imgs/avatar/22.jpg',
                  'title': 'Susanna Simmons',
                  'time': '12 August',
                  'description': 'If you could learn any language, what would you choose?',
              },
              {
                  'id': 4,
                  'image': 'assets/imgs/avatar/17.jpg',
                  'title': 'Savage Mayer',
                  'time': '10 August',
                  'description': 'If you could learn any language, what would you choose?',
              },
              {
                  'id': 5,
                  'image': 'assets/imgs/avatar/18.jpg',
                  'title': 'Britney Soto',
                  'time': '5 August',
                  'description': 'If you could learn any language, what would you choose?',
              },
            ]
        };
    }

    //* Data Set for page 3
    getDataForLayout3 = (): any => {
        return {
            'toolbarTitle': 'Profile With Cards Image',
            'image': 'assets/imgs/avatar/21.jpg',
            'title': 'Carolyn Guerrero',
            'subtitle': 'From New York',
            'button': 'Follow',
            'icon': "chatbubble-ellipses",
            'followers': 'Followers',
            'valueFollowers': '439',
            'following': 'Following',
            'valueFollowing': '297',
            'posts': 'Posts',
            'valuePosts': '43',
            'items': [
                {
                    'id': 1,
                    'category': 'Rooms',
                    'backgroundCard': 'assets/imgs/background/5.jpg',
                    'title': 'The Peninsula Beijing',
                    'like': {
                        'icon': 'thumbs-up',
                        'text': 'Like',
                        'number': '4',
                        'isActive': true
                    },
                    'comment': {
                        'icon': 'chatbubbles',
                        'number': '4',
                        'text': 'Comments',
                        'isActive': false
                    }
                },
                {
                    'id': 2,
                    'category': 'Rooms',
                    'backgroundCard': 'assets/imgs/background/6.jpg',
                    'title': 'The Peninsula Chicago',
                    'like': {
                        'icon': 'thumbs-up',
                        'text': 'Like',
                        'number': '4',
                        'isActive': true
                    },
                    'comment': {
                        'icon': 'chatbubbles',
                        'number': '4',
                        'text': 'Comments',
                        'isActive': false
                    }
                },
                {
                    'id': 3,
                    'category': 'Rooms',
                    'backgroundCard': 'assets/imgs/background/7.jpg',
                    'title': 'The Peninsula Manilae',
                    'like': {
                        'icon': 'thumbs-up',
                        'text': 'Like',
                        'number': '4',
                        'isActive': true
                    },
                    'comment': {
                        'icon': 'chatbubbles',
                        'number': '4',
                        'text': 'Comments',
                        'isActive': false
                    }
                }
            ]
        };
    }

    //* Data Set for page 4
    getDataForLayout4 = (): any => {
        return {
            'toolbarTitle': 'Profile With Cards',
            'image': 'assets/imgs/avatar/23.jpg',
            'title': 'Amanda Smith',
            'subtitle': 'Extreme coffee lover. Twitter maven. Internet practitioner. Beeraholic.',
            'followers': 'Followers',
            'valueFollowers': '439',
            'following': 'Following',
            'valueFollowing': '297',
            'posts': 'Posts',
            'valuePosts': '43',
            'buttonFollow': 'Follow',
            'buttonMessage': 'Message',
            'items': [
              {
                  'id': 1,
                  'subtitle': 'Rooms',
                  'title': 'Wynn Macau',
                  'time': '22 August',
                  'description': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
              },
              {
                  'id': 2,
                  'subtitle': 'Rooms',
                  'title': 'The St. Regis Aspen Resort',
                  'time': '19 August',
                  'description': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
              },
              {
                  'id': 3,
                  'subtitle': 'Rooms',
                  'title': 'The Ritz-Carlton Montreal',
                  'time': '12 August',
                  'description': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
              },
              {
                  'id': 4,
                  'subtitle': 'Rooms',
                  'title': 'Park Hyatt Vienna',
                  'time': '10 August',
                  'description': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
              },
              {
                  'id': 5,
                  'subtitle': 'Rooms',
                  'title': 'Mandarin Oriental, Paris',
                  'time': '5 August',
                  'description': 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
              },
            ]
        };
    }

    //* Data Set for page 5
    getDataForLayout5 = (): any => {
        return {
            'toolbarTitle': 'Profile With Big Avatar',
            'image': 'assets/imgs/avatar/22.jpg',
            'title': 'Carolyn Guerrero',
            'subtitle': 'Extreme coffee lover. Twitter maven. Internet practitioner. Beeraholic.',
            'followers': 'Followers',
            'valueFollowers': '439',
            'following': 'Following',
            'valueFollowing': '297',
            'posts': 'Posts',
            'valuePosts': '43',
            'buttonFollow': 'Follow'
        };
    }

    load(item: any): Observable<any> {
        this.loadingService.show();
        if (AppSettings.IS_FIREBASE_ENABLED) {
            return new Observable(observer => {
                this.af
                    .object('profile/' + item.theme)
                    .valueChanges()
                    .subscribe(snapshot => {
                        this.loadingService.hide();
                        observer.next(snapshot);
                        observer.complete();
                    }, err => {
                        this.loadingService.hide();
                        observer.error([]);
                        observer.complete();
                    });
            });
        } else {
            return new Observable(observer => {
                this.loadingService.hide();
                observer.next(this.getDataForTheme(item));
                observer.complete();
            });
        }
    }
}
